import EmbeddedContinueButton from './EmbeddedContinueButton';

export default EmbeddedContinueButton;
